import React from "react";
import { MdCall, MdLocationOn } from "react-icons/md";
import { BsFillEnvelopeFill } from "react-icons/bs";

/* The five offices exactly as supplied (2026-09-26), Head Office first, in a
   plain left-aligned grid (the short last row is not centred). Karachi and
   USA have no email in the supplied list, so none is shown. `map` keeps the
   existing pinned links for Lahore, Bolton and Cheyenne; the other two open a
   Maps search for their address. */
const mapSearch = (address) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

const OFFICES = [
  {
    title: "Head Office",
    address: "Office # 11-2 B2 Township, Lahore, Pakistan.",
    phone: "+92 301 4900495",
    email: "atif@mbasolutions.co",
    map: "https://goo.gl/maps/7cvXBpX4e7CYaNxK9",
  },
  {
    title: "Islamabad Office",
    address: "Office# 2, 2nd Floor, Plaza# 16, Sector A, DHA Phase 2, Islamabad",
    phone: "+92 333 4880885",
    email: "sales.isb@mbasolutions.co",
  },
  {
    title: "Karachi Office",
    address: "Office # 4-K, Chorangi Near Makkah Hotel, North Karachi Pakistan",
    phone: "+92 333 8400 134",
  },
  {
    title: "UK Office",
    address: "Unit 11 Moses Gate Workshops, Gladys Street, Bolton, England, BL3 2QG",
    phone: "+44 7300 037260",
    email: "Sohaib@mbasolutions.co",
    map: "https://maps.app.goo.gl/8ZHiNYBzCdKA7nLt5",
  },
  {
    title: "USA Office",
    address: "525 Randall Ave Ste 100 Cheyenne, WY 82001",
    phone: "+1 307 400 1335",
    map: "https://maps.app.goo.gl/QrpX2SFEX25deo8M7",
  },
];

const tel = (phone) => `tel:${phone.replace(/[^\d+]/g, "")}`;

function ContactSection2() {
  return (
    <div className="mt-10 md:mt-14 mb-20 md:mb-24" id="contact-offices">
      <ul className="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-6 xl:grid-cols-3 md:mx-10 list-none p-0">
        {OFFICES.map((office, i) => (
          <li
            key={office.title}
            className="group relative flex w-full flex-col rounded-[22px] bg-white p-7 shadow-md border border-transparent hover:border-orange-200 hover:shadow-2xl transition-all duration-300 ease-out"
          >
            <div className="flex items-center gap-3">
              <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-orange-50 border border-orange-100">
                <MdLocationOn size={26} className="text-orange-500" aria-hidden="true" />
              </span>
              <h2 className="text-[20px] font-semibold leading-tight text-[#1B1C19]">
                {office.title}
                {i === 0 && (
                  <span className="ml-2 align-middle rounded-full bg-orange-500 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-white">
                    HQ
                  </span>
                )}
              </h2>
            </div>

            <a
              href={office.map || mapSearch(office.address)}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 text-[15px] leading-6 text-[#3f4046] hover:text-orange-600 transition-colors"
            >
              {office.address}
            </a>

            <div className="mt-auto space-y-2 pt-5">
              <a
                href={tel(office.phone)}
                className="flex items-center gap-2.5 text-[15px] font-medium text-[#1B1C19] hover:text-orange-600 transition-colors"
              >
                <MdCall size={18} className="text-orange-500 flex-shrink-0" aria-hidden="true" />
                {office.phone}
              </a>
              {office.email && (
                <a
                  href={`mailto:${office.email}`}
                  className="flex items-center gap-2.5 text-[15px] font-medium text-[#1B1C19] hover:text-orange-600 transition-colors break-all"
                >
                  <BsFillEnvelopeFill size={15} className="text-orange-500 flex-shrink-0" aria-hidden="true" />
                  {office.email}
                </a>
              )}
            </div>
            <span className="absolute left-0 right-0 bottom-0 h-1 bg-orange-500 rounded-b-[22px] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-center" />
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ContactSection2;
